import { useState } from 'react';
import PropTypes from 'prop-types';

import ReactTicker from 'react-ticker';

import map from 'lodash/fp/map';

import styled from '@emotion/styled';

import Typography from 'Components/Typography';

const Root = styled.div`
  width: 100%;
  height: 64px;
  margin: 0px;
`;

const StyledReactTicker = styled(ReactTicker)`
  width: 100%;
`;

const StyledTypography = styled(Typography)`
  display: block;
  flex-flow: row;
  align-items: center;
  height: 64px;
  width: max-content;
  flex-wrap: nowrap;
  margin: 0px;
  line-height: 64px;
  text-transform: uppercase;
  color: ${({ fontcolor }) => fontcolor};
`;

const Ticker = ({ content, showDash, hasBorder, borderColor, color }) => {
  const borderStyle = hasBorder ? `1px solid ${borderColor}` : 'none';

  // For accessibility purpose: infinite animation should be stoppable
  const [animationRunning, setAnimationRunning] = useState(true);

  return (
    <Root
      className="remove-in-percy"
      onClick={() => {
        setAnimationRunning(!animationRunning);
      }}
      onKeyPress={() => {
        setAnimationRunning(!animationRunning);
      }}
      style={{ borderTop: borderStyle, borderBottom: borderStyle }}
      tabIndex={0}
    >
      <StyledReactTicker direction="toLeft" move offset="1%" speed={animationRunning ? 7 : 0}>
        {() => (
          <StyledTypography fontcolor={color} variant="mono1">
            {map(
              entry =>
                showDash ? (
                  <span key={entry}>&nbsp;&nbsp;&nbsp;{entry}&nbsp;&nbsp;&nbsp;-</span>
                ) : (
                  <span key={entry}>{entry}&nbsp;&nbsp;&nbsp;</span>
                ),
              content
            )}
          </StyledTypography>
        )}
      </StyledReactTicker>
    </Root>
  );
};

Ticker.propTypes = {
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  showDash: PropTypes.bool,
  hasBorder: PropTypes.bool,
  borderColor: PropTypes.string,
  color: PropTypes.string,
};

Ticker.defaultProps = {
  showDash: true, // To be backward compatible
  hasBorder: false,
  borderColor: 'black',
  color: '#6a7365',
};

export default Ticker;
